export default "__VITE_ASSET__Bav$LQxG__"